import { render, staticRenderFns } from "./automation-details.vue?vue&type=template&id=14059864&scoped=true"
import script from "./automation-details.vue?vue&type=script&lang=js"
export * from "./automation-details.vue?vue&type=script&lang=js"
import style0 from "./automation-details.vue?vue&type=style&index=0&id=14059864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14059864",
  null
  
)

export default component.exports